var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterBrandWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "115px",
    height: "149px",
    viewBox: "0 0 115 149",
    style: {
      enableBackground: "new 0 0 115 149"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED7427;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,110.4c-5.9,0-10.8-1.1-14.7-5.3l6.1-6.3c2,2.1,5.5,2.8,8.6,2.8c3.8,0,5.5-1.3,5.5-3.6 c0-1-0.2-1.8-0.8-2.4c-0.5-0.5-1.3-0.9-2.6-1.1l-4.7-0.7c-3.4-0.5-6-1.7-7.8-3.6c-1.8-1.9-2.7-4.6-2.7-8.1 c0-7.4,5.3-12.7,14.1-12.7c5.5,0,9.7,1.4,13.1,4.8l-6,6.2c-2.4-2.5-5.7-2.4-7.3-2.4c-3.3,0-4.7,2-4.7,3.7c0,0.5,0.2,1.2,0.8,1.9 c0.5,0.5,1.3,1,2.7,1.2l4.7,0.7c3.5,0.5,6,1.6,7.6,3.3c2.1,2.1,2.9,5.1,2.9,8.8C31.9,105.9,25.1,110.4,16.9,110.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,110.1c-6.5,0-9.1-4.8-9.1-9V69.8h8.9v30.6c0,1.2,0.6,1.9,1.8,1.9h3.1v7.8H41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.3,110.1v-2.5c-1.8,1.9-4.5,2.8-6.8,2.8c-2.8,0-5-1-6.6-2.6c-2.5-2.6-2.9-5.5-2.9-8.7V79.6h8.9v18.2 c0,3.5,2.4,4.2,3.6,4.2s3.6-0.7,3.6-4.2V79.6H70v30.5H61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.5,110.1V91.8c0-3.5-2.4-4.2-3.6-4.2c-1.2,0-3.6,0.7-3.6,4.2v18.2h-8.9V91.8c0-3.5-2.4-4.2-3.6-4.2 c-1.2,0-3.6,0.7-3.6,4.2v18.2h-8.9V79.6H80v2.5c1.8-1.9,4.5-2.8,6.8-2.8c2.9,0,5.2,1,7.1,3.2c2.6-2.3,4.9-3.2,8.3-3.2 c2.8,0,5.4,1,7,2.6c2.5,2.6,3.2,5.5,3.2,8.7v19.5H103.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.9,21.5h-9.1v13.8h9.1c4.4,0,7-3.4,7-6.9C36.9,24.9,34.3,21.5,29.9,21.5 M37.8,74.7L26.2,49.3h-5.4v25.4 H4.6V6.4h26c14.6,0,22.4,10.7,22.4,22c0,9.3-5.5,15.2-10.7,17.8l14.2,28.5H37.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 25.1,
    className: "st0",
    width: 15.1,
    height: 49.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.4,38.2c-0.9-1-2.2-1.4-4.1-1.4c-1.8,0-3.1,0.5-4.1,1.4c-1.9,2-2.2,5.7-2.2,10.7c0,5.1,0.3,8.7,2.2,10.7 c0.9,1,2.2,1.4,4.1,1.4c1.8,0,3.1-0.5,4.1-1.4c1.9-2,2.2-5.7,2.2-10.7C99.6,43.8,99.3,40.2,97.4,38.2 M109.3,68.7 c-2.9,3.3-7.9,6.6-15.9,6.6c-8,0-13-3.4-15.9-6.6C73.3,64,72,59.1,72,48.9c0-10.1,1.3-15.1,5.4-19.8c2.9-3.3,7.9-6.6,15.9-6.6 c8,0,13,3.4,15.9,6.6c4.1,4.7,5.4,9.7,5.4,19.8C114.7,59.1,113.4,64,109.3,68.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.5,11c0,5.6-4.4,10.2-9.8,10.2c-5.4,0-9.8-4.5-9.8-10.2c0-5.6,4.4-10.2,9.8-10.2 C68.1,0.8,72.5,5.4,72.5,11"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102,112.6c3.8,0,7.6,0.2,11,3.8l-5,5.2c-2.1-2.2-4.9-2.2-6.2-2.2c-1.1,0-3.3,0.3-3.3,1.7 c0,0.7,0.3,1.5,1.8,1.7l3.9,0.4c4.4,0.4,7.4,2.5,7.4,7.7c0,5.8-5.1,8.7-10.1,8.7c-4.2,0-7.5-0.6-10-3.2l4.8-5 c1.3,1.3,3.4,1.6,5.4,1.6c1.9,0,2.5-0.9,2.5-1.5c0-0.3,0.1-1.3-1.7-1.5l-3.9-0.4c-5.3-0.5-7.6-3.8-7.6-8.1 C91,115.3,96.1,112.6,102,112.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.6,112.9c5.6,0,7.9,4.2,7.9,7.8v11.4h2.3v6.2h-2.3v7.6h-7.7v-7.6h-4v-6.2h4v-10.8c0-1-0.5-1.6-1.6-1.6h-2.5 v-6.8H82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.7,112.9v2.2c1.6-1.6,3.9-2.5,5.9-2.5c2.4,0,4.3,0.8,5.7,2.3c2.2,2.3,2.5,4.8,2.5,7.6v16.9h-7.7v-15.8 c0-3-2.1-3.6-3.1-3.6c-1,0-3.1,0.6-3.1,3.6v15.8h-7.7v-26.4H63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,132.4c2.9,0,3.2-2.4,3.2-6.2c0-3.8-0.3-6.2-3.2-6.2c-2.9,0-3.2,2.4-3.2,6.2C40.8,130,41.1,132.4,44,132.4  M40.6,112.9v2.2c1.6-1.6,3.2-2.5,5.9-2.5c2.5,0,4.7,0.9,6.2,2.4c2.5,2.6,2.4,7.2,2.4,11.1c0,3.9,0.1,8.5-2.4,11.1 c-1.5,1.5-3.7,2.4-6.1,2.4c-2.5,0-4.2-0.7-5.7-2.2v10.5h-7.7v-35H40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,148.2h-7.7V142H31V148.2z M31,138.3h-7.7v-25.4H31V138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,131.6c0.5,0.5,1.1,0.7,2.1,0.7c0.9,0,1.6-0.2,2.1-0.7c1-1,1.1-2.9,1.1-5.5c0-2.6-0.1-4.5-1.1-5.5 c-0.5-0.5-1.1-0.7-2.1-0.7c-0.9,0-1.6,0.2-2.1,0.7c-1,1-1.1,2.9-1.1,5.5C7.9,128.7,8.1,130.6,9,131.6 M3,116 c1.5-1.7,4.1-3.4,8.2-3.4c4.1,0,6.7,1.7,8.2,3.4c2.1,2.4,2.8,4.9,2.8,10.1c0,5.2-0.7,7.7-2.8,10.1c-1.5,1.7-4.1,3.4-8.2,3.4 c-4.1,0-6.7-1.7-8.2-3.4c-2.1-2.4-2.8-5-2.8-10.1C0.2,120.9,0.8,118.4,3,116"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBrandWork);
export default __webpack_public_path__ + "static/media/footer_brand_work.46bd40dfd0f57217f8d7e0adf6505518.svg";
export { ForwardRef as ReactComponent };